
import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

interface AddCommentModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (content: string) => Promise<void>;
}

export const AddCommentModal = ({ isOpen, onClose, onSave }: AddCommentModalProps) => {
  const [content, setContent] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSave = async () => {
    if (!content.trim()) return;
    
    setIsSubmitting(true);
    try {
      await onSave(content);
      setContent("");
      onClose();
    } catch (error) {
      console.error("Error saving comment:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const quillModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],
      ['link'],
      ['clean']
    ],
  };

  const quillFormats = [
    'bold', 'italic', 'underline', 'strike',
    'list', 'bullet',
    'link'
  ];

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[80%] w-[95%]">
        <DialogHeader>
          <DialogTitle>Add Comment</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="comment">Comment</Label>
            <div className="min-h-[200px]">
              <ReactQuill
                id="comment"
                placeholder="Write your comment here..."
                value={content}
                onChange={setContent}
                modules={quillModules}
                formats={quillFormats}
                className="h-[200px] mb-12"
              />
            </div>
          </div>
          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={onClose} disabled={isSubmitting}>
              Cancel
            </Button>
            <Button 
              onClick={handleSave} 
              disabled={!content.trim() || isSubmitting}
            >
              {isSubmitting ? "Saving..." : "Save Comment"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
